import { ClientPlatform } from '@ps/platform-message-framework/common/ClientPlatform';
import { TournamentState } from '@ps/poker-games-tile-mappers';
import type { TrackedTranslation } from '@ps/web-core-intl';

import type { HSPPlatform } from '../types/MTT';
import { HSPPlatformEnum } from '../types/MTT';

import {
  TXTCLI_Announced,
  TXTCLI_Cancelled,
  TXTCLI_Completed,
  TXTCLI_Flighted,
  TXTCLI_Full_tourn_state,
  TXTCLI_Late_RegX,
  TXTCLI_Paused,
  TXTCLI_Phase,
  TXTCLI_Registering,
  TXTCLI_Restricted,
  TXTCLI_Running,
  TXTCLI_Seating
} from './index.messages.json';

const SECOND = 1000;
export const MINUTE: number = 60 * SECOND;
export const THOUSAND = 1000;
export const MILLION = 1000000;
export const BILLION = 1000000000;

export const TIME = {
  SECOND: 1000,
  MINUTE: 1000 * 60,
  HOUR: 1000 * 60 * 60,
  DAY: 1000 * 60 * 60 * 24,
  WEEK: 1000 * 60 * 60 * 24 * 7,
  TWO_WEEKS: 1000 * 60 * 60 * 24 * 7 * 2,
  MONTH: 1000 * 60 * 60 * 24 * 30,
  YEAR: 1000 * 60 * 60 * 24 * 365
};

export const TIME_IN_SECOND = {
  SECOND: 1,
  MINUTE: 60,
  HOUR: 60 * 60,
  DAY: 60 * 60 * 24,
  WEEK: 60 * 60 * 24 * 7,
  TWO_WEEKS: 60 * 60 * 24 * 7 * 2,
  MONTH: 60 * 60 * 24 * 30,
  YEAR: 60 * 60 * 24 * 365
};

export const EMBEDDED_RESOLVER_PREFIX = 'pokerstars://resolve/';

export const TournamentStateTranslations: Record<TournamentState, TrackedTranslation> = {
  [TournamentState.ANNOUNCED]: TXTCLI_Announced,
  [TournamentState.CANCELLED]: TXTCLI_Cancelled,
  [TournamentState.COMPLETED]: TXTCLI_Completed,
  [TournamentState.FLIGHTED]: TXTCLI_Flighted,
  [TournamentState.FULL]: TXTCLI_Full_tourn_state,
  [TournamentState.LATE_REGISTRATION]: TXTCLI_Late_RegX,
  [TournamentState.PAUSED]: TXTCLI_Paused,
  [TournamentState.PHASE]: TXTCLI_Phase,
  [TournamentState.REGISTERING]: TXTCLI_Registering,
  [TournamentState.RESTRICTED]: TXTCLI_Restricted,
  [TournamentState.RUNNING]: TXTCLI_Running,
  [TournamentState.SEATING]: TXTCLI_Seating
};

export const CLIENT_HSP_PLATFORM_MAP: Record<ClientPlatform, HSPPlatform> = {
  [ClientPlatform.UNKNOWN_PLATFORM]: HSPPlatformEnum.UNKNOWN,
  [ClientPlatform.WIN]: HSPPlatformEnum.WIN,
  [ClientPlatform.MAC]: HSPPlatformEnum.MAC,
  [ClientPlatform.I_OS]: HSPPlatformEnum.I_OS,
  [ClientPlatform.ANDROID]: HSPPlatformEnum.ANDROID,
  [ClientPlatform.WEB]: HSPPlatformEnum.WEB,
  [ClientPlatform.CORE]: HSPPlatformEnum.CORE,
  [ClientPlatform.LAST]: HSPPlatformEnum.LAST
};
